var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Page 1 Copy 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Research-Widget",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Popular-Research",
    transform: "translate(-2724.000000, -343.000000)",
    fill: "#34ACD9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Recent-Research",
    transform: "translate(2442.000000, 158.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Top-10-(1x2)-Copy-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.775795,186.251851 L289.201296,190.824763 C288.932901,191.093727 288.932901,191.529548 289.201296,191.798512 C289.46969,192.06685 289.906839,192.067476 290.175249,191.798512 L294.74787,187.227478 L294.74787,188.756241 C294.74787,189.10099 295.027893,189.381564 295.373935,189.381564 C295.718756,189.381564 296,189.1016 296,188.756241 L296,185.625323 C296,185.452941 295.92969,185.297068 295.816579,185.183383 C295.703471,185.070299 295.546948,185 295.374546,185 L292.242969,185 C291.898148,185 291.617515,185.279964 291.617515,185.625933 C291.617515,185.970682 291.897538,186.251867 292.242969,186.251867 L293.775795,186.251851 Z M294.6,190.964971 L294.6,197.429906 C294.6,198.296775 293.974917,199 293.203423,199 L283.396577,199 C282.625082,199 282,198.295546 282,197.429906 L282,187.970094 C282,187.103225 282.625082,186.4 283.396577,186.4 L290.121636,186.4 L287.040006,186.4 C287.388221,186.4 287.670003,186.681785 287.670003,187.030003 C287.670003,187.378222 287.388221,187.660006 287.040006,187.660006 L283.61865,187.660006 C283.418091,187.660006 283.259979,187.848267 283.259979,188.080218 L283.259979,197.319845 C283.259979,197.54748 283.42055,197.740057 283.61865,197.740057 L292.981192,197.740057 C293.181751,197.740057 293.339865,197.551796 293.339865,197.319845 L293.339865,193.960038 C293.339865,193.611819 293.621646,193.330035 293.969861,193.330035 C294.318076,193.330035 294.599858,193.611819 294.599858,193.960038 L294.6,190.964971 Z",
    id: "Page-1-Copy-2"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLinkIcon);
export default __webpack_public_path__ + "static/media/externalLinkIcon.8c4045b49f4895aa07093a689e4c2c24.svg";
export { ForwardRef as ReactComponent };